var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fb-share-link"},[_c('a',{attrs:{"href":_vm.link,"title":"Facebook","data-share":"facebook"},on:{"click":function($event){_vm.share(_vm.link)}}},[_c('i',{staticClass:"fa fa-facebook"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb68db5c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/vue/components/share/FacebookShare.vue
// module id = 34
// module chunks = 0